import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericContentModule } from '@com-delta-idp/mnx-ui-kit';
import { StipulationComponent } from './stipulation.component';

@NgModule({
  declarations: [StipulationComponent],
  imports: [CommonModule, GenericContentModule],
  exports: [StipulationComponent]
})
export class StipulationModule {}
